import { render, staticRenderFns } from "./loadingInfinity.vue?vue&type=template&id=1e31b212&scoped=true&"
import script from "./loadingInfinity.vue?vue&type=script&lang=js&"
export * from "./loadingInfinity.vue?vue&type=script&lang=js&"
import style0 from "./loadingInfinity.vue?vue&type=style&index=0&id=1e31b212&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e31b212",
  null
  
)

export default component.exports